module.exports = __webpack_public_path__ + "src/assets/images/login/nitro_main_mobile.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/login/nitro_main_mobile.png
// module id = 2318
// module chunks = 4